import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCategories } from '../firebase/categories';
import { getSettings } from '../firebase/settings';
import { Category } from '../types';
import { CircularProgress } from '@mui/material';

const Hero = () => {
  const navigate = useNavigate();
  const [featuredCategories, setFeaturedCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [imageError, setImageError] = useState(false);
  const [heroImage, setHeroImage] = useState<string>('/logo_bigotess.png');
  
  const fallbackLogoText = "Bigotes Streaming";
  
  useEffect(() => {
    loadData();
  }, []);
  
  const loadData = async () => {
    try {
      const [categories, settings] = await Promise.all([
        getCategories(),
        getSettings()
      ]);
      
      const featured = categories.filter(cat => cat.isFeaturedTop);
      setFeaturedCategories(featured);
      
      if (settings.heroImage) {
        setHeroImage(settings.heroImage);
      }
    } catch (error) {
      console.error('Error loading hero data:', error);
    } finally {
      setLoading(false);
    }
  };
  
  if (loading) {
    return (
      <div className="relative min-h-[18px] flex items-center justify-center">
        <CircularProgress sx={{ color: '#00ffff' }} />
      </div>
    );
  }
  
  return (
    <div className="relative min-h-[150px] sm:min-h-[200px] w-full flex flex-col items-center justify-start py-6 overflow-hidden">
      {/* Logo y contenido principal */}
      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Logo o texto alternativo */}
          <div className="flex justify-center items-center mb-6 sm:mb-8">
            <div className="relative w-full max-w-[800px] flex justify-center">
              <img 
                src={heroImage}
                alt="Bigotes Streaming"
                className="w-auto h-auto max-w-full max-h-[200px] sm:max-h-[250px] md:max-h-[280px] object-contain transition-all duration-300 hover:scale-105"
                style={{
                  filter: 'drop-shadow(0 0 15px rgba(0, 255, 255, 0.2))'
                }}
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            </div>
          </div>
          
          {/* Botones de categorías */}
          {featuredCategories.length > 0 && (
            <div className="flex justify-center gap-3 sm:gap-4 flex-wrap mt-4">
              {featuredCategories.map(category => (
                <button
                  key={category.id}
                  onClick={() => navigate(`/categoria/${category.name.toLowerCase()}`)}
                  className="bg-black/60 backdrop-blur-md border border-neon-green/50 text-neon-green px-6 py-2 rounded-full font-orbitron font-bold hover:bg-neon-green/20 hover:border-neon-green hover:shadow-[0_0_20px_rgba(0,255,0,0.4)] transition-all duration-300 text-sm sm:text-base uppercase tracking-wider transform hover:-translate-y-1"
                >
                  {category.name}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Hero;
